import React, { useState } from "react";
import { AiOutlineClose, AiOutlineMenu, AiOutlineShoppingCart } from "react-icons/ai";
import { useNavigate, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [nav, setNav] = useState(false);
  const { getCartCount } = useCart();
  const cartCount = getCartCount();

  const handleNav = () => {
    setNav(!nav);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };
  
  return (
    <>
      <nav className="bg-rose-50/90 backdrop-blur-sm shadow-soft sticky top-0 z-50 border-b border-rose-100">
        <div className='flex justify-between items-center h-15 max-w-7xl mx-auto px-6 text-black'>
          
          {/* Logo */}
          <h1 
            onClick={() => navigate('/')}
            className='text-5xl text-rose-700 m-4' style={{ fontFamily: 'Great Vibes, cursive' }}
          >
            Dear Bea Flowers
          </h1>
          
          {/* Desktop Navigation */}
          <div className="flex items-center gap-10">
            <ul className='hidden md:flex items-center gap-2'>
              <li 
                className={`px-4 py-2 cursor-pointer font-sans font-medium transition-all duration-200 rounded-full ${
                  isActive('/') 
                    ? 'text-rose-600 font-bold bg-rose-50' 
                    : 'text-gray-700 hover:text-rose-500 hover:bg-rose-50'
                }`}
                onClick={() => navigate('/')}
              >
                Home
              </li>
              <li 
                className={`px-4 py-2 cursor-pointer font-sans font-medium transition-all duration-200 rounded-full ${
                  isActive('/contact') 
                    ? 'text-rose-600 font-bold bg-rose-50' 
                    : 'text-gray-700 hover:text-rose-500 hover:bg-rose-50'
                }`}
                onClick={() => navigate('/contact')}
              >
                Contact
              </li>
          
            </ul>

            {/* Cart Icon */}
            <div 
              onClick={() => navigate('/cart')}
              className="relative p-3 rounded-full hover:bg-rose-50 transition-all duration-200 hover:scale-110 cursor-pointer group"
            >
              <AiOutlineShoppingCart 
                size={28} 
                className="text-gray-700 group-hover:text-rose-600 transition-colors duration-200" 
              />
              {cartCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-gradient-rose text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center shadow-soft animate-pulse">
                  {cartCount}
                </span>
              )}
            </div>
          </div>
          
          {/* Mobile Menu Button */}
          <div 
            onClick={handleNav} 
            className='block md:hidden cursor-pointer z-[110] p-2 rounded-lg hover:bg-rose-50 transition-all'
          >
            {nav ? (
              <AiOutlineClose size={24} className="text-rose-600" />
            ) : (
              <AiOutlineMenu size={24} className="text-gray-700" />
            )}
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {nav && (
        <div 
          onClick={handleNav} 
          className='fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-[100] md:hidden transition-opacity duration-300'
        />
      )}

      {/* Mobile Menu Drawer */}
      <div className={nav 
        ? 'fixed left-0 top-0 w-[75%] h-full bg-gradient-soft ease-in-out duration-500 z-[110] shadow-romantic' 
        : 'fixed left-[-100%] ease-in-out duration-500 z-[110]'
      }>
        <div className="p-6">
          <h1 
            onClick={() => { navigate('/'); handleNav(); }}
              className='text-5xl text-rose-700 m-4' style={{ fontFamily: 'Great Vibes, cursive' }}
          >
            Dear Bea Flowers
          </h1>
          
          <ul className='space-y-2'>
            <li 
              className={`p-4 rounded-2xl cursor-pointer transition-all duration-200 font-sans font-medium ${
                isActive('/') 
                  ? 'text-rose-600 font-bold bg-white shadow-soft' 
                  : 'text-gray-700 hover:bg-white hover:shadow-soft'
              }`}
              onClick={() => { navigate('/'); handleNav(); }}
            >
              Home
            </li>
            <li 
              className={`p-4 rounded-2xl cursor-pointer transition-all duration-200 font-sans font-medium ${
                isActive('/contact') 
                  ? 'text-rose-600 font-bold bg-white shadow-soft' 
                  : 'text-gray-700 hover:bg-white hover:shadow-soft'
              }`}
              onClick={() => { navigate('/contact'); handleNav(); }}
            >
              Contact
            </li>
    
            
            <li 
              className='p-4 rounded-2xl cursor-pointer hover:bg-white hover:shadow-soft transition-all duration-200 flex items-center gap-3 mt-6 border-t-2 border-rose-100 pt-6 font-sans font-medium text-gray-700' 
              onClick={() => { navigate('/cart'); handleNav(); }}
            >
              <AiOutlineShoppingCart size={24} className="text-rose-600" />
              <span>Cart</span>
              {cartCount > 0 && (
                <span className="ml-auto bg-gradient-rose text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center">
                  {cartCount}
                </span>
              )}
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Navbar;